module.exports = __webpack_public_path__ + "img/zone02-amsterdam.161b3cd6.png";